import { render, staticRenderFns } from "./commit_changes_modal.vue?vue&type=template&id=977da25c"
import script from "./commit_changes_modal.vue?vue&type=script&lang=js"
export * from "./commit_changes_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports